import React, { useState } from 'react';

import { Outlet, useParams, useSearchParams } from 'react-router-dom';

import dayjs from 'dayjs';

import { toast } from 'react-toastify';

import { Modal, Textarea, PaginationControls, Button, Heading, TextLink } from '../shared/ui';
import { useGetPostsQuery } from '../services/posts.api';

import { baseUrlFiles } from '../configs/api/api.config';
import { useSetIdeasMutation } from '../services/idea.api';

const COUNT_NEWS_ON_PAGE = 4;

const Info = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get('page');
  const items = searchParams.get('items');
  const itemsPerPage = items ? +items : COUNT_NEWS_ON_PAGE;
  const params = useParams();
  const roomName = params.id;
  const [showModal, setShowModal] = useState(false);
  const { data } = useGetPostsQuery({
    page: page ? +page : 1,
    itemsPerPage: items ? +items : COUNT_NEWS_ON_PAGE,
    'sort[is_fixed]': 'desc',
    'sort[created_at]': 'desc',
  });
  const [text, setText] = useState('');
  const [sendIdeas] = useSetIdeasMutation();

  if (roomName) {
    return <Outlet />;
  }

  const sendIdeasToServer = async () => {
    if (!text.trim()) {
      return;
    }
    try {
      const res = await sendIdeas(text);

      if (res) {
        toast.success('Ваше предложение отправлено');
        setText('');
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div className="w-full pb-[85px]">
        <Heading size="xl" className="mb-5">
          Информация
        </Heading>

        <Button size="md" onClick={() => setShowModal(true)} className="mb-5">
          Предложить идею или улучшения существующего инструмента
        </Button>

        <div className="grid grid-cols-12 gap-[20px] mb-[40px]">
          {data?.posts &&
            data?.posts?.length > 0 &&
            data.posts.map((item) => (
              <div
                key={item.id}
                className="flex flex-col col-span-12 sm:col-span-6 min-h-[220px] p-5 bg-surface-muted rounded-card"
              >
                <div className="flex flex-col md:flex-row gap-[10px] pb-[7px]">
                  <div className="md:w-1/2 h-[166px] flex">
                    {item?.image && (
                      <img src={baseUrlFiles + item.image} className="w-full h-full object-cover" alt="" />
                    )}
                  </div>
                  <Heading size="lg" as="h3" className="md:w-1/2 mb-4">
                    {item.title}
                  </Heading>
                </div>
                <div className="mb-[3px]">
                  <div className="min-h-[48px] text-ui-strong text-ink-muted break-words">{item?.excerpt}</div>
                  <TextLink to={`${item.id}`} underline="hover" className="text-ui-strong">
                    Читать подробнее...
                  </TextLink>
                </div>
                <div className="mt-auto">
                  <TextLink to={item.link} target="_blank" underline="hover" className="text-ui-strong">
                    {item.link_text}
                  </TextLink>
                  <div className="w-max p-[5px_15px] bg-accent text-ui-strong rounded-chip mt-[7px]">
                    {dayjs(item.created_at).format('DD.MM.YYYY')}
                  </div>
                </div>
              </div>
            ))}
        </div>

        {data?.totalItems ? (
          <PaginationControls
            page={page ? +page : 1}
            totalPages={Math.ceil(data.totalItems / itemsPerPage)}
            onPageChange={(next) => setSearchParams({ page: String(next), items: String(itemsPerPage) })}
          />
        ) : null}
      </div>

      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        fullscreenOnMobile
        title="Предложить идею"
        footer={
          <Button
            variant="dark"
            onClick={() => {
              sendIdeasToServer();
              setShowModal(false);
            }}
            size="lg"
            fullWidth
            className="sm:w-auto"
            disabled={!text.trim()}
          >
            Отправить
          </Button>
        }
      >
        <Textarea
          rows={7}
          placeholder="Опишите идею инструмента для психолога или улучшение существующего, и ZiNGiZi поможет реализовать."
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      </Modal>
    </>
  );
};

export default Info;
